import React,{useState,useEffect} from 'react'
import { useMediaQuery } from 'react-responsive'
import jquery from '../services/jquery-script'
import { WindowReload, WindowURL, WindowLocation, RouteURL, WindowLocationBaseUrl } from '../services/redirect'

import SidebarMenu from './sidebar-menu'
import AccountComponent from '../pages/UserManagement/administrator/account'
import LogoImage from '../assets/images/logo_admin.png'
import LogoDarkImage from '../assets/images/logo_admin_dark.png'

export default function PageHeaderComponent(props){


  /*------------------------------------------------------
   SIDEBAR
  -------------------------------------------------------*/

  const isDesktopOrLaptop = useMediaQuery({query: '(min-width: 1366px)'});
  const [sidebar, setSidebar] = useState(true);


  // Onload settings sidebar
  function OnloadClassSidebar(data){
    jquery();
    if(data){
      setSidebar(true);
      document.body.classList.add("pushSidebar");
      document.body.classList.remove("floatSidebar");
    }else{
      setSidebar(false);
      document.body.classList.add("floatSidebar");
      document.body.classList.remove("pushSidebar");
    }
  }


  // Handle toggle icon
  function SidebarToggle(data){
    jquery();
    if(isDesktopOrLaptop){
      if(data){
        document.body.classList.remove("pushSidebar");
        document.body.classList.remove("floatSidebar");
        setSidebar(false);
      }else{
        document.body.classList.add("pushSidebar");
        document.body.classList.remove("floatSidebar");
        setSidebar(true);
      }
    }else{
      if(data){
        setSidebar(false);
      }else{
        setSidebar(true);
      }
      document.body.classList.add("floatSidebar");
      document.body.classList.remove("pushSidebar");
    }
  }

  // Close when other modal is open on smaller screens
  function OncloseSidebarModal(data){
    if(!isDesktopOrLaptop){
      if(data){
        document.body.classList.add("floatSidebar");
        document.body.classList.remove("pushSidebar");
        setSidebar(false);
      }
    }
  }

  // Handle resize window trigger
  function handleResize(){
    OnloadClassSidebar(isDesktopOrLaptop);
  }
  window.addEventListener('resize', handleResize);



  /*------------------------------------------------------
   OTHER MODAL
  -------------------------------------------------------*/
  function ClassBody(data){
    if(data){
      document.body.classList.add("modal");
    }else{
      document.body.classList.remove("modal");
    }
  }
  const [account, setAccount] = useState(false);
  function CallbackFunction(data){
    if(data.close){
      ClassBody(false);
      setAccount(false);
    }
  }

  function OpenFunction(data){
    OncloseSidebarModal(sidebar);
    ClassBody(true);
    if(data.account){
      setAccount(true);
    }
  }


  function ExactLogin(){
    window.open(
      WindowLocationBaseUrl('/api/admin/exact/auth.php?type=exact_login'),
      '_blank'
    );
  }

  useEffect(()=>{
    OnloadClassSidebar(isDesktopOrLaptop);
    console.log(props.exact);
  },[]);

  return (
    <React.Fragment>

       {/*----------------------------------------
          PAGE HEADER MENU
         ---------------------------------------*/}
        <div className="app-header-wrapper">
            <div className="app-header-container">
               <div className="app-header-logo"><img src={LogoDarkImage} alt=""/></div>
               <div className="app-header-menu">
                  <div>
                     <ul>
                        <li onClick={()=>SidebarToggle(sidebar)}><a><i className="bars icon"></i></a></li>
                     </ul>
                  </div>
                  <div>
                    <ul>
                      
                       <li><a href={WindowURL('/dashboard')}><i className="bell outline icon"></i></a></li>
                       <li onClick={()=>OpenFunction({account:true})}><a><i className="user outline icon"></i> Hi, {props.data.name} <i className="angle down icon"></i></a></li>
                       {props.exact.status=='NONE'&&<li onClick={()=>ExactLogin()}
                        style={{'background-color':'#fee3e1','border-left':'1px solid #bfc4c7'}}>
                          <a><i className="uil-unlock icon"></i> Exact</a>
                        </li>}
                    </ul>
                  </div>
               </div>
            </div>
        </div>

        {/*----------------------------------------
           MODAL INCLUDE
          ---------------------------------------*/}
        {sidebar&&<SidebarMenu data={props.data} callback={CallbackFunction}/>}
        {account&&<AccountComponent data={props.data} callback={CallbackFunction}/>}


    </React.Fragment>
  )
}
